/* kidsplace.bg demo store - shared helpers */

/* ---------------------------------------------------------------------------
   MERGED TAXONOMY across both suppliers.
   MouseToys covers wooden / educational / role play / puzzles.
   Guga covers scooters, furniture, audio, school bags, baby gear.
   Age and Gifts sit first on purpose: those are the pages people search for.
   --------------------------------------------------------------------------- */
/* menu is rendered in Liquid from the real collections */

function eur(n){ return n.toFixed(2).replace('.', ',') + ' €'; }
function bgn(n){ return n.toFixed(2).replace('.', ',') + ' лв.'; }

function card(p){
  var was  = p.eur * 1.18;
  var sale = (p.sku.charCodeAt(3) % 3 === 0);
  return '<a class="pc" href="product.html?sku=' + p.sku + '">'
    + (sale ? '<span class="badge">-15%</span>' : '')
    + '<div class="ph"><img src="' + p.img + '" alt="' + p.name + '" loading="lazy"></div>'
    + '<div class="bd">'
    +   '<div class="nm">' + p.name + '</div>'
    +   '<div class="pr num">' + eur(p.eur) + ' / ' + bgn(p.bgn)
    +     (sale ? '<s>' + eur(was) + '</s>' : '')
    +   '</div>'
    + '</div></a>';
}

function renderRail(id, list){
  var el = document.getElementById(id);
  if (el) el.innerHTML = list.map(card).join('');
}

function qs(name){ return new URLSearchParams(location.search).get(name); }

/* ---------------- category mega menu ---------------- */
function buildMenu(){
  var btn = document.querySelector('.cats');
  var panel = document.getElementById('megaMenu');
  if (!btn || !panel || btn.dataset.wired) return;
  btn.dataset.wired = '1';
  function setOpen(open){
    panel.hidden = !open;
    btn.setAttribute('aria-expanded', String(open));
    btn.classList.toggle('open', open);
  }
  btn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); setOpen(panel.hidden); });
  document.addEventListener('click', function(e){
    if (!panel.hidden && !panel.contains(e.target) && e.target !== btn) setOpen(false);
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && !panel.hidden) { setOpen(false); btn.focus(); }
  });

  /* "Виж всички" toggles the same panel - bound directly so the outside-click
     handler above does not close it a split second before we reopen it */
  var more = document.querySelector('.nav-more-btn');
  if (more){
    more.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      var open = panel.hidden;
      setOpen(open);
      more.textContent = open ? 'Скрий' : 'Виж всички';
      more.setAttribute('aria-expanded', String(open));
    });
  }
}

/* ---------------- tabs ---------------- */
document.addEventListener('click', function(e){
  var t = e.target.closest('.tabs button');
  if (!t) return;
  var wrap = t.closest('.tabwrap') || document;
  wrap.querySelectorAll('.tabs button').forEach(function(b){
    b.setAttribute('aria-selected', String(b === t));
  });
  wrap.querySelectorAll('.panel').forEach(function(p){
    p.classList.toggle('on', p.id === t.dataset.panel);
  });
});

document.addEventListener('DOMContentLoaded', buildMenu);
if (document.readyState !== 'loading') buildMenu();


/* mobile filter drawer */
document.addEventListener('click', function(e){
  var t = e.target.closest('.filter-toggle');
  if (!t) return;
  var side = document.getElementById('sideFilters');
  if (!side) return;
  var open = side.classList.toggle('open');
  t.setAttribute('aria-expanded', String(open));
});


/* ---------------- cart drawer ---------------- */
(function(){
  var drawer  = document.getElementById('cartDrawer');
  var overlay = document.getElementById('cdOverlay');
  if (!drawer || !overlay) return;

  function money(cents){
    return (cents/100).toFixed(2).replace('.', ',') + ' \u20ac';
  }

  function open(){
    drawer.hidden = false; overlay.hidden = false;
    requestAnimationFrame(function(){ drawer.classList.add('on'); overlay.classList.add('on'); });
    document.body.style.overflow = 'hidden';
  }
  function close(){
    drawer.classList.remove('on'); overlay.classList.remove('on');
    document.body.style.overflow = '';
    setTimeout(function(){ drawer.hidden = true; overlay.hidden = true; }, 280);
  }

  function render(cart){
    var body  = document.getElementById('cdBody');
    var foot  = document.getElementById('cdFoot');
    var badge = document.getElementById('cartBadge');
    var count = document.getElementById('cdCount');
    if (badge){ badge.textContent = cart.item_count; badge.hidden = cart.item_count === 0; }
    if (count) count.textContent = '(' + cart.item_count + ')';

    if (!cart.item_count){
      body.innerHTML = '<div class="cd-empty"><p><b>Количката е празна</b></p>'
        + '<p>Разгледайте категориите и добавете нещо, което детето ще ползва наистина.</p>'
        + '<a class="btn btn--sm" href="/collections">Към магазина</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;

    body.innerHTML = cart.items.map(function(it){
      return '<div class="cd-item" data-key="' + it.key + '">'
        + '<a class="cd-img" href="' + it.url + '">'
        +   (it.image ? '<img src="' + it.image + '&width=160" alt="">' : '')
        + '</a>'
        + '<div class="cd-info">'
        +   '<a class="cd-title" href="' + it.url + '">' + it.product_title + '</a>'
        +   '<div class="cd-price">' + money(it.final_price) + '</div>'
        +   '<div class="cd-qty">'
        +     '<button type="button" data-key="' + it.key + '" data-qty="' + (it.quantity-1) + '">\u2212</button>'
        +     '<span>' + it.quantity + '</span>'
        +     '<button type="button" data-key="' + it.key + '" data-qty="' + (it.quantity+1) + '">+</button>'
        +   '</div>'
        + '</div>'
        + '<button type="button" class="cd-remove" data-key="' + it.key + '" data-qty="0">\u00d7</button>'
        + '</div>';
    }).join('');

    var FREE = 4990;
    var total = document.getElementById('cdTotal');
    if (total) total.textContent = money(cart.total_price);
    var ship = foot ? foot.querySelector('.cd-ship') : null;
    var bar  = foot ? foot.querySelector('.cd-shipbar span') : null;
    if (ship){
      if (cart.total_price < FREE){
        ship.className = 'cd-ship';
        ship.innerHTML = 'До безплатна доставка остават <b>' + money(FREE - cart.total_price) + '</b>';
        if (bar) bar.style.width = Math.min(100, cart.total_price*100/FREE) + '%';
      } else {
        ship.className = 'cd-ship cd-ship--ok';
        ship.textContent = 'Доставката е безплатна';
        if (bar) bar.style.width = '100%';
      }
    }
  }

  function refresh(){
    return fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); }).then(render);
  }

  /* add to cart without leaving the page */
  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[name=add]');
    if (btn){ btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Добавяме...'; }
    fetch('/cart/add.js', {method:'POST', body:new FormData(form)})
      .then(function(r){ return r.json(); })
      .then(function(){ return refresh(); })
      .then(function(){ rememberProduct(); if (cont) { try { var l = sessionStorage.getItem('kp_last_product'); if (l) cont.setAttribute('href', l); } catch(e){} } open(); })
      .catch(function(){ form.submit(); })
      .finally(function(){
        if (btn){ btn.disabled = false; btn.textContent = btn.dataset.label || 'Добави в количката'; }
      });
  });

  /* quantity and remove */
  document.addEventListener('click', function(e){
    var b = e.target.closest('.cd-qty button, .cd-remove');
    if (!b) return;
    fetch('/cart/change.js', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({id: b.dataset.key, quantity: parseInt(b.dataset.qty, 10)})
    }).then(function(r){ return r.json(); }).then(render);
  });

  /* remember which product the drawer was opened from */
  function rememberProduct(){
    if (document.body.classList.contains('template-product')){
      try { sessionStorage.setItem('kp_last_product', location.pathname + location.search); } catch(e){}
    }
  }
  rememberProduct();

  var cont = document.getElementById('cdContinue');
  if (cont){
    /* keep a sensible href for no-JS / direct /cart visits */
    try {
      var last = sessionStorage.getItem('kp_last_product');
      if (last) cont.setAttribute('href', last);
    } catch(e){}

    cont.addEventListener('click', function(e){
      /* on the product page the drawer is an overlay: just close it and stay put */
      if (document.body.classList.contains('template-product')){
        e.preventDefault();
        close();
        return;
      }
      var target = null;
      try { target = sessionStorage.getItem('kp_last_product'); } catch(e2){}
      if (target){
        e.preventDefault();
        location.href = target;
      }
      /* otherwise follow the href to the catalogue */
    });
  }

  document.getElementById('cdClose').addEventListener('click', close);
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !drawer.hidden) close(); });
  var link = document.getElementById('cartLink');
  if (link) link.addEventListener('click', function(e){ e.preventDefault(); refresh().then(open); });
})();


/* "Виж всички" opens the same mega menu as the КАТЕГОРИИ button */



/* ---------- price slider: keep the two handles from crossing ---------- */
(function(){
  document.querySelectorAll('.pslider').forEach(function(form){
    var lo=form.querySelector('.ps-lo'), hi=form.querySelector('.ps-hi'),
        nlo=form.querySelector('.ps-nlo'), nhi=form.querySelector('.ps-nhi'),
        fill=form.querySelector('.ps-fill'), cap=parseFloat(form.dataset.cap)||100;
    if(!lo||!hi) return;

    function paint(){
      var a=Math.min(+lo.value,+hi.value), b=Math.max(+lo.value,+hi.value);
      fill.style.left=(a/cap*100)+'%';
      fill.style.width=((b-a)/cap*100)+'%';
    }
    function sync(src){
      if(+lo.value > +hi.value){
        if(src==='lo') lo.value=hi.value; else hi.value=lo.value;
      }
      nlo.value = (+lo.value>0) ? lo.value : '';
      nhi.value = (+hi.value<cap) ? hi.value : '';
      paint();
    }
    lo.addEventListener('input',function(){sync('lo');});
    hi.addEventListener('input',function(){sync('hi');});
    lo.addEventListener('change',function(){form.submit();});
    hi.addEventListener('change',function(){form.submit();});
    nlo.addEventListener('input',function(){ lo.value=nlo.value||0; paint(); });
    nhi.addEventListener('input',function(){ hi.value=nhi.value||cap; paint(); });
    paint();
  });
})();


/* ---------- product gallery: tap a thumb, swipe the main image ---------- */
(function(){
  var shot=document.getElementById('shot');
  if(!shot) return;
  var thumbs=Array.prototype.slice.call(document.querySelectorAll('.thumbs button'));
  if(!thumbs.length) return;

  function show(i){
    var b=thumbs[i]; if(!b) return;
    // The main shot now carries a srcset for LCP. A srcset always wins over src,
    // so swapping only .src would leave the previous image on screen.
    shot.removeAttribute('srcset');
    shot.removeAttribute('sizes');
    shot.src=b.getAttribute('data-src');
    thumbs.forEach(function(t,j){ t.setAttribute('aria-current', j===i?'true':'false'); });
    idx=i;
  }
  var idx=0;

  /* delegated so it works for touch and mouse alike */
  document.querySelector('.thumbs').addEventListener('click',function(e){
    var b=e.target.closest('button'); if(!b) return;
    e.preventDefault();
    show(thumbs.indexOf(b));
  });

  /* arrows, for pointers that cannot swipe */
  var prev=document.getElementById('galPrev');
  var next=document.getElementById('galNext');
  function arrows(){
    if(prev) prev.disabled = idx<=0;
    if(next) next.disabled = idx>=thumbs.length-1;
  }
  if(prev) prev.addEventListener('click',function(){ show(Math.max(idx-1,0)); arrows(); });
  if(next) next.addEventListener('click',function(){ show(Math.min(idx+1,thumbs.length-1)); arrows(); });
  arrows();

  /* the arrows only reach the images that have a thumbnail, and the thumbnail
     strip is capped at five - so they cover exactly what is reachable */
  document.addEventListener('keydown',function(e){
    if(e.key==='ArrowLeft'){ show(Math.max(idx-1,0)); arrows(); }
    if(e.key==='ArrowRight'){ show(Math.min(idx+1,thumbs.length-1)); arrows(); }
  });

  /* swipe left/right on the big image */
  var x0=null;
  shot.addEventListener('touchstart',function(e){ x0=e.changedTouches[0].clientX; },{passive:true});
  shot.addEventListener('touchend',function(e){
    if(x0===null) return;
    var dx=e.changedTouches[0].clientX-x0; x0=null;
    if(Math.abs(dx)<40) return;
    show(dx<0 ? Math.min(idx+1,thumbs.length-1) : Math.max(idx-1,0));
    arrows();
  },{passive:true});
})();


/* shorter placeholder on narrow screens so it is never clipped mid-word */
(function(){
  var i=document.querySelector('.search input[name="q"]');
  if(!i) return;
  var full=i.getAttribute('placeholder');
  function set(){ i.setAttribute('placeholder', window.innerWidth<560 ? 'Търси играчка или марка' : full); }
  set(); window.addEventListener('resize', set);
})();


/* mobile: tapping a category row opens its children instead of navigating */
(function(){
  var list = document.querySelector('.mega-list');
  if (!list) return;
  list.addEventListener('click', function(e){
    if (window.innerWidth > 1050) return;
    var top = e.target.closest('.mega-top');
    if (!top) return;
    var item = top.parentElement;
    if (!item.classList.contains('has-kids')) return;   // no children, just follow the link
    e.preventDefault();
    var wasOpen = item.classList.contains('open');
    list.querySelectorAll('.mega-item.open').forEach(function(x){ x.classList.remove('open'); });
    if (!wasOpen) item.classList.add('open');
  });
})();


/* show the sticky add-to-cart once the real buy button is off screen.
   A scroll listener rather than IntersectionObserver: the observer only fires on
   threshold crossings and was missing the change on programmatic scrolls. */
(function(){
  var bar = document.getElementById('stickyAtc');
  if (!bar) return;
  var anchor = document.querySelector('.buy form[action*="/cart/add"] button[name="add"]');
  if (!anchor) return;

  var shown = false, ticking = false;
  function update(){
    ticking = false;
    var past = anchor.getBoundingClientRect().bottom < 0;
    if (past === shown) return;
    shown = past;
    bar.classList.toggle('show', past);
    bar.setAttribute('aria-hidden', past ? 'false' : 'true');
  }
  function onScroll(){
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', onScroll, {passive:true});
  update();
})();


/* ---------------- helper bot ---------------- */
(function(){
  var open = document.getElementById('hbOpen');
  var panel = document.getElementById('hbPanel');
  if (!open || !panel) return;
  var body = document.getElementById('hbBody');
  var form = document.getElementById('hbForm');
  var input = document.getElementById('hbInput');

  /* keep the launcher clear of the sticky add-to-cart bar */
  var satc = document.getElementById('stickyAtc');
  if (satc && window.MutationObserver){
    new MutationObserver(function(){
      document.body.classList.toggle('body-has-satc', satc.classList.contains('show'));
    }).observe(satc, {attributes:true, attributeFilter:['class']});
  }

  function show(v){
    panel.hidden = !v;
    open.setAttribute('aria-expanded', String(v));
    open.style.display = v ? 'none' : '';
    if (v) setTimeout(function(){ input.focus(); }, 60);
  }
  open.addEventListener('click', function(){ show(true); });
  document.getElementById('hbClose').addEventListener('click', function(){ show(false); });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && !panel.hidden) show(false);
  });

  function add(html, mine){
    var d = document.createElement('div');
    d.className = 'hb-msg ' + (mine ? 'hb-me' : 'hb-bot');
    d.innerHTML = html;
    body.appendChild(d);
    body.scrollTop = body.scrollHeight;
    return d;
  }

  var ANSWERS = {
    dostavka: 'Доставяме за <b>1-3 работни дни</b> със Спиди или Еконт, до офис или до адрес. ' +
      'Поръчка до 16:00 в работен ден тръгва същия ден. Доставката е <b>безплатна при поръчка над 49.90 евро</b>, ' +
      'под тази сума е от 3.50 до 4.00 евро.',
    vrashtane: 'Имате <b>30 дни</b> да върнете продукта. Ако е неползван и в оригиналната опаковка, ' +
      'връщаме сумата. Пишете ни на info@kidsplace.bg и ви обясняваме стъпките.',
    plashtane: 'Плащате с <b>наложен платеж</b> при получаване - в брой на куриера. ' +
      'Фактура издаваме при заявка, напишете данните в бележката към поръчката.',
    nalichnost: 'Всичко, което виждате като налично, е в склад и тръгва веднага. ' +
      'Ако продуктът е изчерпан, оставете имейл на неговата страница и ви пишем в деня, ' +
      'в който се върне.',
    vazrast: 'Всеки продукт показва препоръчана възраст от производителя. ' +
      'Може и да филтрирате по възраст във всяка категория - изберете Възраст в панела с филтри.',
    kontakt: 'Пишете на <a href="mailto:info@kidsplace.bg">info@kidsplace.bg</a> или ' +
      'през <a href="/pages/za-kontakti">формата за контакт</a>. Отговаряме в работни дни.'
  };

  var KEYS = [
    [/достав|куриер|спиди|еконт|колко.*дни|кога.*получ/i, 'dostavka'],
    [/връщ|замен|рекламац|счупен|дефект/i, 'vrashtane'],
    [/плащ|наложен|карта|фактур/i, 'plashtane'],
    [/наличн|изчерпан|склад|кога.*дойде/i, 'nalichnost'],
    [/контакт|телефон|имейл|мейл|обадя/i, 'kontakt']
  ];

  /* phrased as looking for something -> always search, never answer policy */
  var WANTS = /търс|искам|имате ли|има ли|покаж|препоръч|подходящ|подарък|за дете|за момче|за момиче|за бебе|нещо за|какво да/i;

  /* age bands we actually have, in months so ranges can be compared */
  var BANDS = [
    {tag:'age-0-1',  lo:0,  hi:1,  label:'до 1 година'},
    {tag:'age-1-2',  lo:1,  hi:2,  label:'1 до 2 години'},
    {tag:'age-3-4',  lo:3,  hi:4,  label:'3 до 4 години'},
    {tag:'age-5-7',  lo:5,  hi:7,  label:'5 до 7 години'},
    {tag:'age-8-11', lo:8,  hi:11, label:'8 до 11 години'},
    {tag:'age-12+',  lo:12, hi:99, label:'над 12 години'}
  ];

  function readAge(t){
    var m = t.match(/(\d{1,2})\s*(?:до|-|и)\s*(\d{1,2})\s*год/i);
    if (m) return {lo:+m[1], hi:+m[2]};
    m = t.match(/(\d{1,2})\s*год/i);
    if (m) return {lo:+m[1], hi:+m[1]};
    if (/месец|бебе|новородено/i.test(t)) return {lo:0, hi:1};
    return null;
  }

  function bandsFor(a){
    return BANDS.filter(function(b){ return b.lo <= a.hi && b.hi >= a.lo; });
  }

  /* suggest.json gives the price in currency units, not cents */
  function money(v){
    var n = parseFloat(String(v).replace(/[^0-9.,]/g, '').replace(',', '.'));
    return isNaN(n) ? '' : n.toFixed(2).replace('.', ',') + ' \u20ac';
  }

  function search(q, age){
    var thinking = add('Търся...', false);
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection&resources[limit]=5')
      .then(function(r){ return r.json(); })
      .then(function(d){
        var res = (d.resources && d.resources.results) || {};
        var prods = res.products || [], cols = res.collections || [];
        var h = '';

        if (!prods.length && !cols.length){
          h = 'Не намирам нищо за <b>' + q + '</b>. Опитайте с по-обща дума, ' +
              'или ни пишете на <a href="mailto:info@kidsplace.bg">info@kidsplace.bg</a>.';
          thinking.innerHTML = h;
          return;
        }

        if (prods.length){
          h += 'Ето какво намерих за <b>' + q + '</b>:<div class="hb-hits">';
          prods.forEach(function(p){
            var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : '';
            h += '<a class="hb-hit" href="' + p.url + '">' +
                 (img ? '<img src="' + img + '&width=120" alt="" loading="lazy">' : '') +
                 '<span class="hb-hit-t">' + p.title + '</span>' +
                 '<span class="hb-hit-p">' + (p.price ? money(p.price) : '') + '</span></a>';
          });
          h += '</div>';
        }

        /* an age was mentioned: point at the filtered category, not just products */
        if (age && cols.length){
          var bs = bandsFor(age);
          if (bs.length){
            h += '<br>За възраст ' +
                 (age.lo === age.hi ? age.lo + ' години' : age.lo + ' до ' + age.hi + ' години') +
                 ' вижте: ' +
                 bs.map(function(b){
                   return '<a href="' + cols[0].url + '/' + b.tag + '">' +
                          cols[0].title + ', ' + b.label + '</a>';
                 }).join(', ') + '.';
          }
        } else if (cols.length){
          h += (prods.length ? '<br>Или разгледайте: ' : 'Разгледайте: ');
          h += cols.map(function(c){
            return '<a href="' + c.url + '">' + c.title + '</a>';
          }).join(', ') + '.';
        }

        thinking.innerHTML = h;
        body.scrollTop = body.scrollHeight;
      })
      .catch(function(){
        thinking.innerHTML = 'Нещо се обърка с търсенето. Пишете ни на ' +
          '<a href="mailto:info@kidsplace.bg">info@kidsplace.bg</a>.';
      });
  }

  function ask(text){
    add(text, true);

    var age = readAge(text);
    var looking = WANTS.test(text);

    /* policy answers only when the message is not a product request */
    if (!looking){
      for (var i = 0; i < KEYS.length; i++){
        if (KEYS[i][0].test(text)){ add(ANSWERS[KEYS[i][1]], false); return; }
      }
      if (/възраст|год/i.test(text) && !age){ add(ANSWERS.vazrast, false); return; }
    }

    /* Strip the age phrasing so it does not drown the real search terms.
       No  or \w here: both are ASCII-only in JS, so they cut Cyrillic words
       in half - "години" was becoming "ини". */
    var q = text
      .replace(/от\s*\d{1,2}\s*(?:до|-)\s*\d{1,2}\s*год[а-я]*/gi, ' ')
      .replace(/\d{1,2}\s*(?:до|-)\s*\d{1,2}\s*год[а-я]*/gi, ' ')
      .replace(/\d{1,2}\s*год[а-я]*/gi, ' ')
      .replace(/\d{1,2}\s*месец[а-я]*/gi, ' ')
      .replace(/за\s+(дете|деца|момче|момиче|бебе|бебета)(?![а-я])/gi, ' ')
      .replace(/(търся|търсим|искам|имате ли|има ли|покажи ми|покажи|препоръчай|препоръчайте|нещо за|какво да|подходящ[а-я]*)(?![а-я])/gi, ' ')
      .replace(/\s+(за|на|от|до|и|с)\s*$/i, '')
      .replace(/\s{2,}/g, ' ')
      .trim();

    if (!q){
      if (age){
        var bs = bandsFor(age);
        add('За тази възраст вижте ' +
            bs.map(function(b){ return '<a href="/collections/detski-igrachki/' + b.tag + '">' + b.label + '</a>'; }).join(', ') +
            '. Или напишете какво точно търсите - например „тротинетка" или „конструктор".', false);
        return;
      }
      add('Напишете какво търсите - например „тротинетка", „дървен пъзел" или „кукла".', false);
      return;
    }
    search(q, age);
  }

  document.getElementById('hbChips').addEventListener('click', function(e){
    var b = e.target.closest('button[data-q]');
    if (!b) return;
    add(b.textContent.trim(), true);
    add(ANSWERS[b.dataset.q], false);
  });

  form.addEventListener('submit', function(e){
    e.preventDefault();
    var v = input.value.trim();
    if (!v) return;
    input.value = '';
    ask(v);
  });
})();


/* ---------------------------------------------------------------
   PDP quantity stepper.
   The markup shipped with #minus / #q / #plus but nothing ever bound them, so the
   buttons did nothing on every product and the form always submitted quantity 1.
   The hidden input is what the form posts, so both have to stay in step.
   --------------------------------------------------------------- */
(function(){
  var minus = document.getElementById('minus');
  var plus  = document.getElementById('plus');
  var out   = document.getElementById('q');
  var input = document.getElementById('qtyInput');
  if (!minus || !plus || !out || !input) return;

  var MAX = 99;
  function set(n){
    n = Math.max(1, Math.min(MAX, n));
    out.textContent = n;
    input.value = n;
    minus.disabled = (n <= 1);
  }
  minus.addEventListener('click', function(){ set(parseInt(input.value, 10) - 1); });
  plus.addEventListener('click',  function(){ set(parseInt(input.value, 10) + 1); });
  set(parseInt(input.value, 10) || 1);
})();


/* ------------------------------------------------------------------
   Delivery date, not "1-3 working days".

   A parent buying for a birthday needs a date, so this names one. Working days,
   the 16:00 cut-off and the official Bulgarian holidays are all resolved against
   the visitor's own clock: the page is cached, so a server-rendered date would
   go stale the same day it was printed.
   ------------------------------------------------------------------ */
(function(){
  var box = document.getElementById('eta');
  if (!box) return;

  var DAY = ['неделя','понеделник','вторник','сряда','четвъртък','петък','събота'];
  var MON = ['януари','февруари','март','април','май','юни','юли','август',
             'септември','октомври','ноември','декември'];
  /* Официални празници. Great and Holy Friday through Easter Monday move every
     year, so they are listed rather than computed. */
  var HOL = {
    '2026-01-01':1,'2026-03-03':1,'2026-04-10':1,'2026-04-11':1,'2026-04-12':1,
    '2026-04-13':1,'2026-05-01':1,'2026-05-06':1,'2026-05-24':1,'2026-09-06':1,
    '2026-09-22':1,'2026-12-24':1,'2026-12-25':1,'2026-12-26':1,
    '2027-01-01':1,'2027-03-03':1,'2027-04-30':1,'2027-05-01':1,'2027-05-02':1,
    '2027-05-03':1,'2027-05-06':1,'2027-05-24':1,'2027-09-06':1,'2027-09-22':1,
    '2027-12-24':1,'2027-12-25':1,'2027-12-26':1
  };
  var CUTOFF = 16;

  function key(d){
    return d.getFullYear() + '-' + ('0'+(d.getMonth()+1)).slice(-2) + '-' + ('0'+d.getDate()).slice(-2);
  }
  function working(d){ var w = d.getDay(); return w !== 0 && w !== 6 && !HOL[key(d)]; }
  function addWorking(d, n){
    var x = new Date(d.getTime());
    while (n > 0){ x.setDate(x.getDate()+1); if (working(x)) n--; }
    return x;
  }
  function fmt(d){ return DAY[d.getDay()] + ', ' + d.getDate() + ' ' + MON[d.getMonth()]; }
  /* "при вас понеделник" is not Bulgarian; it needs the preposition, and
     вторник takes във rather than в. */
  function on(d){ return (d.getDay() === 2 ? 'във ' : 'в ') + fmt(d); }
  function midnight(d){ return new Date(d.getFullYear(), d.getMonth(), d.getDate()); }

  var now = new Date();
  var today = midnight(now);

  /* Dispatch: today if it is a working day and we are still before the cut-off,
     otherwise the next working day. */
  var dispatch = (working(today) && now.getHours() < CUTOFF) ? today : addWorking(today, 1);
  var early = addWorking(dispatch, 1);
  var late  = addWorking(dispatch, 3);

  var top = document.getElementById('etaTop');
  var sub = document.getElementById('etaSub');
  if (dispatch.getTime() === today.getTime()){
    var left = new Date(today.getTime()); left.setHours(CUTOFF,0,0,0);
    var mins = Math.round((left - now) / 60000);
    var h = Math.floor(mins/60), m = mins%60;
    top.textContent = 'Поръчайте до 16:00 днес';
    sub.innerHTML = 'и е при вас <b>' + on(early) + '</b>, най-късно ' + on(late)
                  + '. <span class="eta-left">Остават ' + (h ? h + ' ч ' : '') + m + ' мин</span>';
  } else {
    top.textContent = 'Изпращаме ' + on(dispatch);
    sub.innerHTML = 'и е при вас <b>' + on(addWorking(dispatch,1)) + '</b>, най-късно ' + on(late) + '.';
  }

  box.hidden = false;
})();


/* ------------------------------------------------------------------
   "Често купувани заедно": keep the total honest and keep the form valid.

   Unticking a row disables its hidden inputs so it is not posted at all, then
   the remaining rows are renumbered. Shopify reads items[0], items[1] ... in
   order, and a gap in the sequence drops everything after it.
   ------------------------------------------------------------------ */
(function(){
  var form = document.querySelector('.bundle');
  if (!form) return;
  var out = document.getElementById('bundleTotal');
  if (!out) return;

  var base = parseInt(out.getAttribute('data-base'), 10) || 0;
  var rows = Array.prototype.slice.call(form.querySelectorAll('.bx-toggle'));
  var label = form.querySelector('.bundle-sum span');

  function money(c){ return (c/100).toFixed(2).replace('.', ',') + ' €'; }

  function sync(){
    var total = base, n = 1, idx = 1;
    rows.forEach(function(cb){
      var i = cb.getAttribute('data-i');
      var ins = form.querySelectorAll('input[type=hidden][data-i="' + i + '"]');
      var price = cb.closest('.bx').querySelector('.bx-price');
      Array.prototype.forEach.call(ins, function(el){ el.disabled = !cb.checked; });
      cb.closest('.bx').classList.toggle('bx--off', !cb.checked);
      if (cb.checked){
        total += parseInt(price.getAttribute('data-price'), 10) || 0;
        n++;
        Array.prototype.forEach.call(ins, function(el){
          el.name = el.name.replace(/items\[\d+\]/, 'items[' + idx + ']');
        });
        idx++;
      }
    });
    out.textContent = money(total);
    if (label) label.textContent = n === 1 ? 'Общо за 1 артикул' : 'Общо за ' + n + ' артикула';
  }

  rows.forEach(function(cb){ cb.addEventListener('change', sync); });
  sync();
})();


/* ---------------------------------------------------------------
   Article tables scroll sideways. The fade on the right edge is only
   drawn when there is something to scroll to, and disappears at the end -
   a permanent fade over a table that fits looks like a rendering fault.
   --------------------------------------------------------------- */
(function(){
  var wraps = document.querySelectorAll('.tablewrap');
  if (!wraps.length) return;
  Array.prototype.forEach.call(wraps, function(w){
    var sc = w.querySelector('.tablewrap-scroll');
    if (!sc) return;
    function sync(){
      var over = sc.scrollWidth - sc.clientWidth > 4;
      w.classList.toggle('is-over', over);
      w.classList.toggle('is-end', over && sc.scrollLeft + sc.clientWidth >= sc.scrollWidth - 4);
    }
    sc.addEventListener('scroll', sync, {passive:true});
    window.addEventListener('resize', sync);
    sync();
  });
})();
